import { useTranslation } from 'react-i18next';

const POINT_COUNT = 3;

function splitParagraphs(value: string): string[] {
  return value
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export default function TrainingMeaning() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] overflow-hidden">
              <img
                src="/images/generated/training-basic-2026.jpg"
                alt={t('butlerTrainingSchool.meaning.imgAlt')}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <p className="text-[13px] text-foreground-400 tracking-[0.04em] mt-2 text-center">
              {t('butlerTrainingSchool.meaning.imgCaption')}
            </p>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              {t('butlerTrainingSchool.meaning.label')}
            </p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('butlerTrainingSchool.meaning.title')}
            </h2>
            <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
              {t('butlerTrainingSchool.meaning.titleEn')}
            </p>
            <div className="gold-line mb-6"></div>

            {splitParagraphs(String(t('butlerTrainingSchool.meaning.para1'))).map((part, index) => (
              <p key={`para1-${index}`} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-5">
                {part}
              </p>
            ))}
            {splitParagraphs(String(t('butlerTrainingSchool.meaning.para2'))).map((part, index) => (
              <p key={`para2-${index}`} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-8">
                {part}
              </p>
            ))}

            <div className="space-y-5">
              {Array.from({ length: POINT_COUNT }, (_, idx) => (
                <div key={idx} className="flex gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                      {t(`butlerTrainingSchool.meaning.${idx}.title`)}
                    </h3>
                    {splitParagraphs(String(t(`butlerTrainingSchool.meaning.${idx}.desc`))).map((part, index) => (
                      <p key={index} className="text-[16px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                        {part}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
